<template>
    <div>
        <MenuAccount/>
        <AccountDayList/>
    </div>
</template>

<script>

import MenuAccount from '@/components/menuadmin/account/accountheader/MenuAccount.vue'
import AccountDayList from '@/components/menuadmin/account/accountcreate/AccountDayList.vue'
export default {
    name:'accountDay',
    components:{
        MenuAccount,
        AccountDayList,
    },
}
</script>